import React from "react";
import { Link } from "react-router-dom";
import OTPScreen2 from "./OtpScreen2";

// Template9 — minimal light card with a cover image, generous whitespace.
// Generic (no company branding), self-contained styling.
const COVER_IMAGE =
  "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?auto=format&fit=crop&w=1200&q=80";

const styles = `
.tmpl9-root{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:linear-gradient(160deg,#eef2ff 0%,#faf5ff 55%,#fdf2f8 100%);font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#0f172a;}
.tmpl9-root *{box-sizing:border-box;}
.tmpl9-card{width:100%;max-width:430px;background:#fff;border-radius:24px;box-shadow:0 30px 60px rgba(79,70,229,.12),0 2px 6px rgba(15,23,42,.05);overflow:hidden;}
.tmpl9-cover{position:relative;height:150px;}
.tmpl9-cover img{width:100%;height:100%;object-fit:cover;display:block;}
.tmpl9-cover-tint{position:absolute;inset:0;background:linear-gradient(120deg,rgba(99,102,241,.55),rgba(236,72,153,.35));}
.tmpl9-avatar{position:absolute;left:50%;bottom:-32px;transform:translateX(-50%);width:64px;height:64px;border-radius:18px;background:linear-gradient(135deg,#6366f1,#ec4899);display:flex;align-items:center;justify-content:center;box-shadow:0 12px 26px rgba(99,102,241,.4);border:4px solid #fff;}
.tmpl9-body{padding:48px 40px 40px;}
.tmpl9-title{font-size:25px;font-weight:700;margin:0 0 6px;text-align:center;letter-spacing:-.4px;}
.tmpl9-sub{font-size:14px;color:#64748b;margin:0 0 30px;text-align:center;}
.tmpl9-field{margin-bottom:18px;}
.tmpl9-label{display:block;font-size:12.5px;font-weight:600;color:#475569;margin-bottom:7px;}
.tmpl9-input-wrap{position:relative;}
.tmpl9-input{width:100%;height:48px;border:1px solid #e5e7eb;border-radius:14px;padding:0 44px 0 16px;font-size:15px;color:#0f172a;background:#f9fafb;transition:border-color .15s,box-shadow .15s,background .15s;outline:none;}
.tmpl9-input::placeholder{color:#9ca3af;}
.tmpl9-input:focus{border-color:#6366f1;background:#fff;box-shadow:0 0 0 4px rgba(99,102,241,.12);}
.tmpl9-eye{position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:#9ca3af;padding:6px;display:flex;align-items:center;}
.tmpl9-eye:hover{color:#6366f1;}
.tmpl9-options{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;min-height:20px;}
.tmpl9-check{display:flex;align-items:center;gap:8px;font-size:13.5px;color:#475569;cursor:pointer;user-select:none;}
.tmpl9-check input{width:16px;height:16px;accent-color:#6366f1;cursor:pointer;}
.tmpl9-link{font-size:13.5px;color:#6366f1;font-weight:600;text-decoration:none;}
.tmpl9-link:hover{text-decoration:underline;}
.tmpl9-btn{width:100%;height:50px;border:none;border-radius:14px;background:linear-gradient(135deg,#6366f1,#ec4899);color:#fff;font-size:16px;font-weight:600;cursor:pointer;transition:transform .12s,box-shadow .2s,opacity .2s;box-shadow:0 12px 26px rgba(99,102,241,.32);display:flex;align-items:center;justify-content:center;gap:8px;}
.tmpl9-btn:hover{transform:translateY(-1px);box-shadow:0 16px 34px rgba(99,102,241,.42);}
.tmpl9-btn:active{transform:translateY(0);}
.tmpl9-btn:disabled{opacity:.55;cursor:not-allowed;box-shadow:none;transform:none;}
.tmpl9-recaptcha{margin-bottom:18px;display:flex;justify-content:center;}
.tmpl9-otp-wrap{margin-top:8px;}
`;

const EyeIcon = ({ off }) =>
  off ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

class Template9 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isChecked: false,
      isShowPassword: false,
      twoFAStatus: null,
    };
  }

  updateTwoFAStatus = (t) => {
    this.setState({ twoFAStatus: t });
  };

  onLogin = () => {
    const { email, password, isChecked } = this.state;
    const { authenticationCallback, itemProperties, sessionId, twoFA } = this.props;
    if (isChecked && email !== "") {
      localStorage.username = email;
      localStorage.password = password;
      localStorage.checkbox = isChecked;
    }
    const payload = { email, password };

    if (twoFA) {
      this.props.setError(false);
      this.props.login(payload, () => {
        this.updateTwoFAStatus("OTP");
      });
    } else {
      if (itemProperties && itemProperties.authenticateUsingPlugins) {
        payload["authenticateUsingPlugins"] = true;
        payload["sessionId"] = sessionId;
      }
      this.props.setError(false);
      this.props.login(payload, authenticationCallback);
    }
  };

  togglePasswordVisiblity = () => {
    this.setState({ isShowPassword: !this.state.isShowPassword });
  };

  onKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.onLogin();
    }
  };

  render() {
    const {
      label,
      hasForgotPassword,
      authTemplateTopFormText,
      itemProperties,
      authenticationCallback,
    } = this.props;

    const rememberMe =
      itemProperties && itemProperties.authConfig && itemProperties.authConfig.rememberMe;
    const otpScreenLabel = itemProperties && itemProperties.otpScreenLabel;
    const isOtp = this.state.twoFAStatus === "OTP";

    return (
      <div className="tmpl9-root">
        <style dangerouslySetInnerHTML={{ __html: styles }} />

        <div className="tmpl9-card">
          <div className="tmpl9-cover">
            <img src={COVER_IMAGE} alt="" />
            <div className="tmpl9-cover-tint" />
            <span className="tmpl9-avatar">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <path d="M12 2l2.6 6.8L21 11l-6.4 2.2L12 20l-2.6-6.8L3 11l6.4-2.2z" fill="#fff" />
              </svg>
            </span>
          </div>

          <div className="tmpl9-body">
            {isOtp ? (
              <>
                <h2 className="tmpl9-title">
                  {otpScreenLabel ? otpScreenLabel : "One-Time Password"}
                </h2>
                <p className="tmpl9-sub">
                  Enter the verification code we just sent you.
                </p>
                <div className="tmpl9-otp-wrap">
                  <OTPScreen2
                    authenticationCallback={authenticationCallback}
                    requiredRole={itemProperties && itemProperties.requiredRole}
                    phoneNumber={this.state.email}
                  />
                </div>
              </>
            ) : (
              <>
                <h2 className="tmpl9-title">
                  {authTemplateTopFormText || "Sign in"}
                </h2>
                <p className="tmpl9-sub">Welcome back — let's get you in.</p>

                <div className="tmpl9-field">
                  <label className="tmpl9-label" htmlFor="tmpl9-email">Email</label>
                  <div className="tmpl9-input-wrap">
                    <input
                      id="tmpl9-email"
                      className="tmpl9-input"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      onKeyDown={this.onKeyDown}
                      placeholder="you@example.com"
                      type="text"
                      autoComplete="username"
                    />
                  </div>
                </div>

                <div className="tmpl9-field">
                  <label className="tmpl9-label" htmlFor="tmpl9-password">Password</label>
                  <div className="tmpl9-input-wrap">
                    <input
                      id="tmpl9-password"
                      className="tmpl9-input"
                      value={this.state.password}
                      onChange={(e) => this.setState({ password: e.target.value })}
                      onKeyDown={this.onKeyDown}
                      placeholder="Enter your password"
                      type={this.state.isShowPassword ? "text" : "password"}
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className="tmpl9-eye"
                      onClick={this.togglePasswordVisiblity}
                      aria-label={this.state.isShowPassword ? "Hide password" : "Show password"}
                    >
                      <EyeIcon off={this.state.isShowPassword} />
                    </button>
                  </div>
                </div>

                <div className="tmpl9-options">
                  {rememberMe ? (
                    <label className="tmpl9-check">
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={(e) => this.setState({ isChecked: e.target.checked })}
                      />
                      Remember me
                    </label>
                  ) : (
                    <span />
                  )}
                  {hasForgotPassword ? (
                    <Link className="tmpl9-link" to="/app/forgotpassword">
                      Forgot password?
                    </Link>
                  ) : (
                    <span />
                  )}
                </div>

                {this.props.reCaptchaComponent ? (
                  <div className="tmpl9-recaptcha">{this.props.reCaptchaComponent}</div>
                ) : null}

                <button
                  type="button"
                  className="tmpl9-btn"
                  disabled={this.props.displayReCaptcha}
                  onClick={this.onLogin}
                >
                  {label && label.show ? label.text : "Sign in"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Template9;
